/**
 * @format
 * Entry point for web platform
 */

import {AppRegistry} from 'react-native';
import App from './App';
import appConfig from './app.json';

const appName = appConfig.name;

// Register the app for web
AppRegistry.registerComponent(appName, () => App);

// Start the app for web
const rootTag = document.getElementById('root');
if (rootTag) {
  AppRegistry.runApplication(appName, {
    initialProps: {},
    rootTag,
  });
} else {
  console.error('Root element not found');
}
